import { UnknownAction } from "redux";

export enum ModalTypes {
	SET_MODAL_IS_OPENED = "@modal/SET_MODAL_IS_OPENED",
	RELEASE_MODAL = "@modal/RELEASE_MODAL",
}

export interface ModalState {
	readonly open: boolean;
	readonly name: string | null;
	readonly ownerId?: string;
}

export interface SetModalIsOpened extends UnknownAction {
	type: typeof ModalTypes.SET_MODAL_IS_OPENED;
	payload: { open: boolean; name: string | null; ownerId?: string };
}

export interface ReleaseModal extends UnknownAction {
	type: typeof ModalTypes.RELEASE_MODAL;
	payload: { ownerId: string };
}

export type ModalActionTypes = SetModalIsOpened | ReleaseModal;
